import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqItems = [
    { q: 'faq.q1', a: 'faq.a1' },
    { q: 'faq.q2', a: 'faq.a2' },
    { q: 'faq.q3', a: 'faq.a3' },
    { q: 'faq.q4', a: 'faq.a4' },
    { q: 'faq.q5', a: 'faq.a5' },
    { q: 'faq.q6', a: 'faq.a6' },
  ];

  const toggleIndex = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            {t('faq.title')}
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggleIndex(i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-150"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {t(item.q)}
                </span>
                <span
                  className={`w-5 h-5 flex items-center justify-center shrink-0 text-foreground-500 transition-transform duration-200 ${
                    openIndex === i ? 'rotate-45' : ''
                  }`}
                >
                  <i className="ri-add-line text-lg"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {t(item.a)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}